<template>
  <section class="features" id="features">
    <div class="container">

      <!-- 双引擎 -->
      <div class="section-intro">
        <div class="section-tag">两种AI算法</div>
        <h2>人脸搜索 + 智能搜图，满足不同场景的搜图需求</h2>
      </div>

      <div class="engine-intro-grid">
        <div class="engine-intro-card engine-intro-face">
          <div class="engine-intro-header">
            <div class="engine-intro-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <div>
              <h3>人脸搜索</h3>
              <p>AI精准分析人脸特征</p>
            </div>
          </div>
          <div class="engine-intro-tags">
            <span v-for="(scene, i) in faceTags" :key="scene" class="engine-tag" :class="'tag-' + (i % 6)">{{ scene }}</span>
          </div>
          <ul class="engine-intro-features">
            <li v-for="f in faceFeatures" :key="f">{{ f }}</li>
          </ul>
        </div>

        <div class="engine-intro-card engine-intro-image">
          <div class="engine-intro-header">
            <div class="engine-intro-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            </div>
            <div>
              <h3>智能搜图</h3>
              <p>AI 理解图片语义，搜你想搜</p>
            </div>
          </div>
          <div class="engine-intro-tags">
            <span v-for="(scene, i) in imageTags" :key="scene" class="engine-tag" :class="'tag-' + (i % 6)">{{ scene }}</span>
          </div>
          <ul class="engine-intro-features">
            <li v-for="f in imageFeatures" :key="f">{{ f }}</li>
          </ul>
        </div>
      </div>

      <!-- 四大搜索方式 -->
      <div class="section-intro" style="margin-top: 80px;">
        <div class="section-tag">图库中心</div>
        <h2>本地算力，智能分析</h2>
      </div>

      <div class="lib-grid">
        <div class="lib-card" v-for="item in libFeatures" :key="item.title">
          <div class="lib-icon">
            <span v-html="item.icon"></span>
          </div>
          <h4>{{ item.title }}</h4>
          <p>{{ item.desc }}</p>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'SiteFeatures',
  data() {
    return {
      faceTags: [
        '摄影师', '景区抓拍', '模特外拍', '妆容匹配', '人物纪念册', '体育赛事'
      ],
      imageTags: [
        '服装', '首饰', '箱包', '美妆', '家具', '母婴', '玩具', '数码配件', '运动装备', '包装设计', '插画', '汽车配件', '工艺品', '布料'
      ],
      searchModes: [
        {
          id: 1,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>',
          title: '以图搜图',
          desc: '上传一张图片，快速在本地图库中找到相似或相同的内容'
        },
        {
          id: 2,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>',
          title: '拍照搜图',
          desc: '用摄像头实时拍照，拍摄后立即搜索目标内容'
        },
        {
          id: 3,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="17" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="17" y1="18" x2="3" y2="18"/></svg>',
          title: '以文搜图',
          desc: '输入文字描述，AI 自动理解语义并匹配图库中的图片'
        },
        {
          id: 4,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>',
          title: '截图后搜图',
          desc: '截取任意区域或内容，立即搜索匹配结果'
        }
      ],
      faceFeatures: [
        '基于深度学习的人脸识别技术',
        '出色兼容小脸、侧脸和模糊人脸',
        '支持检测视频中的人物片段'
      ],
      imageFeatures: [
        'AI 语义理解，准确理解图像',
        '智能识图，智能搜图'
      ],
      libFeatures: [
        {
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>',
          title: '自动扫描图库',
          desc: '新增图片自动入库，手动删除照片会自动移出图库，软件不会主动删除图片'
        },
        {
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
          title: '处理能力',
          desc: '专业搜图引擎，十万张照片的快速检索，高清图片轻松应对'
        },
        {
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>',
          title: '格式支持',
          desc: '支持 JPG、PNG、HEIC、MP4、MOV 等多种图片和视频格式'
        },
        {
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
          title: '隐私安全',
          desc: '所有图片和视频完全在本地处理，无需上传网络'
        }
      ]
    }
  }
}
</script>

<style scoped>
.features {
  padding: 80px 0;
  background: #fff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
}

.section-intro {
  text-align: center;
  margin-bottom: 56px;
}

.section-tag {
  display: inline-block;
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  color: #2563eb;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 20px;
  margin-bottom: 16px;
  letter-spacing: 1px;
  text-transform: uppercase;
  border: 1px solid rgba(37, 99, 235, 0.15);
}

.section-intro h2 {
  font-size: 34px;
  font-weight: 800;
  color: #1a202c;
  margin: 0 0 14px;
  letter-spacing: -0.3px;
}

.section-intro p {
  font-size: 17px;
  color: #718096;
  margin: 0;
}

/* 双引擎卡片 */
.engine-intro-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 8px;
}

.engine-intro-card {
  border-radius: 28px;
  padding: 40px 36px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.engine-intro-face {
  background: linear-gradient(160deg, #fefefe 0%, #f8f7ff 100%);
  box-shadow:
    0 1px 3px rgba(79, 70, 229, 0.04),
    0 8px 24px rgba(79, 70, 229, 0.06),
    0 24px 48px rgba(79, 70, 229, 0.04);
  border: 1px solid rgba(79, 70, 229, 0.06);
}

.engine-intro-image {
  background: linear-gradient(160deg, #fefefe 0%, #f0fcfd 100%);
  box-shadow:
    0 1px 3px rgba(8, 145, 178, 0.04),
    0 8px 24px rgba(8, 145, 178, 0.06),
    0 24px 48px rgba(8, 145, 178, 0.04);
  border: 1px solid rgba(8, 145, 178, 0.06);
}

.engine-intro-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.engine-intro-face::before {
  background: linear-gradient(90deg, #4f46e5, #7c3aed, #a855f7);
}

.engine-intro-image::before {
  background: linear-gradient(90deg, #0891b2, #06b6d4, #22d3ee);
}

.engine-intro-card:hover {
  transform: translateY(-6px);
}

.engine-intro-face:hover {
  box-shadow:
    0 4px 12px rgba(79, 70, 229, 0.08),
    0 16px 32px rgba(79, 70, 229, 0.1),
    0 32px 64px rgba(79, 70, 229, 0.06);
}

.engine-intro-image:hover {
  box-shadow:
    0 4px 12px rgba(8, 145, 178, 0.08),
    0 16px 32px rgba(8, 145, 178, 0.1),
    0 32px 64px rgba(8, 145, 178, 0.06);
}

.engine-intro-card:hover::before {
  opacity: 1;
}

.engine-intro-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.engine-intro-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.engine-intro-face .engine-intro-icon {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #fff;
  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.25);
}

.engine-intro-image .engine-intro-icon {
  background: linear-gradient(135deg, #0891b2, #06b6d4);
  color: #fff;
  box-shadow: 0 4px 16px rgba(8, 145, 178, 0.25);
}

.engine-intro-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 4px;
}

.engine-intro-header p {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.engine-intro-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.engine-tag {
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  cursor: default;
  border: 1px solid transparent;
}

.tag-0 { color: #4f46e5; background: rgba(79, 70, 229, 0.1); border-color: rgba(79, 70, 229, 0.15); }
.tag-1 { color: #0891b2; background: rgba(8, 145, 178, 0.1); border-color: rgba(8, 145, 178, 0.15); }
.tag-2 { color: #059669; background: rgba(5, 150, 105, 0.1); border-color: rgba(5, 150, 105, 0.15); }
.tag-3 { color: #d97706; background: rgba(217, 119, 6, 0.1); border-color: rgba(217, 119, 6, 0.15); }
.tag-4 { color: #dc2626; background: rgba(220, 38, 38, 0.1); border-color: rgba(220, 38, 38, 0.15); }
.tag-5 { color: #7c3aed; background: rgba(124, 58, 237, 0.1); border-color: rgba(124, 58, 237, 0.15); }

.engine-tag:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.tag-0:hover { background: rgba(79, 70, 229, 0.18); }
.tag-1:hover { background: rgba(8, 145, 178, 0.18); }
.tag-2:hover { background: rgba(5, 150, 105, 0.18); }
.tag-3:hover { background: rgba(217, 119, 6, 0.18); }
.tag-4:hover { background: rgba(220, 38, 38, 0.18); }
.tag-5:hover { background: rgba(124, 58, 237, 0.18); }

.engine-intro-features {
  list-style: none;
  padding: 0;
  margin: 20px 0 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.engine-intro-features li {
  font-size: 14px;
  color: #475569;
  padding: 10px 14px;
  background: rgba(255,255,255,0.6);
  border-radius: 10px;
  line-height: 1.5;
  position: relative;
  padding-left: 30px;
}

.engine-intro-face .engine-intro-features li::before {
  content: '✓';
  position: absolute;
  left: 12px;
  top: 10px;
  color: #4f46e5;
  font-weight: 700;
  font-size: 13px;
}

.engine-intro-image .engine-intro-features li::before {
  content: '✓';
  position: absolute;
  left: 12px;
  top: 10px;
  color: #0891b2;
  font-weight: 700;
  font-size: 13px;
}

@media (max-width: 768px) {
  .engine-intro-grid { grid-template-columns: 1fr; }
}

/* 四种搜索方式 */
.search-modes {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.mode-card {
  background: linear-gradient(145deg, #f8fbff, #f0f7ff);
  border: 1px solid rgba(78, 140, 255, 0.12);
  border-radius: 20px;
  padding: 32px 24px;
  text-align: center;
  transition: all 0.35s ease;
}

.mode-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(78, 140, 255, 0.14);
  border-color: rgba(78, 140, 255, 0.3);
}

.mode-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #4e8cff, #6ec1e4);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: #fff;
  box-shadow: 0 6px 20px rgba(78, 140, 255, 0.35);
  transition: transform 0.3s ease;
}

.mode-card:hover .mode-icon {
  transform: scale(1.1) rotate(-3deg);
}

.mode-card h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 10px;
}

.mode-card p {
  font-size: 14px;
  color: #718096;
  line-height: 1.65;
  margin: 0;
}

/* 图库 */
.lib-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.lib-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 28px 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.lib-card:hover {
  border-color: rgba(78, 140, 255, 0.3);
  box-shadow: 0 8px 24px rgba(0,0,0,0.06);
  transform: translateY(-4px);
}

.lib-icon {
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  color: var(--primary);
}

.lib-card h4 {
  font-size: 16px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 8px;
}

.lib-card p {
  font-size: 13px;
  color: #718096;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 900px) {
  .search-modes { grid-template-columns: repeat(2, 1fr); }
  .lib-grid { grid-template-columns: repeat(2, 1fr); }
  .section-intro h2 { font-size: 26px; }
}

@media (max-width: 540px) {
  .search-modes { grid-template-columns: 1fr; }
  .lib-grid { grid-template-columns: 1fr; }
  .container { padding: 0 16px; }
}
</style>
